// @flow

import React from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';
import t from 'app/utils/translate';

const Wrapper = glamorous.div(({ theme }) => ({
  backgroundColor: theme.color.primary,
  borderRadius: 3,
  fontSize: 10,
  lineHeight: 1.4,
  color: theme.color.white,
  ...padding(2, 4, '0'),
  textTransform: 'uppercase',
}));

function LivePill() {
  return <Wrapper>{t('LIVE')}</Wrapper>;
}

export default LivePill;
